import React, {useState} from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import DHButtonDefault from "../../general/DHButtonDefault";
import ConfirmWithQuestionDialog from "../../general/ConfirmWithQuestionDialog";

export default function VeranstalterRechnungAnfordernButton({eventOperatorId, disabled, onError, onInfo, onRefresh}) {

    const [rechnungAngefordert, setRechnungAngefordert] = useState(false);
    const [showRechnungAnfordern, setShowRechnungAnfordern] = useState(false);

    const rechnungAnfordern = () => {
        onError(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/rechnung/anfordern/" + eventOperatorId
        FetchUtil.fetchPost(url,
            {},
            (message) => {
                if (message !== null && message !== undefined && message !== "") {
                    onError(message);
                    setShowRechnungAnfordern(false);
                } else {
                    onInfo("Rechnung wurde angefordert.");
                    onRefresh();
                    setRechnungAngefordert(true);
                    setShowRechnungAnfordern(false);
                }
            },
            responseNotOk => {
                onError("Fehler: " + responseNotOk.message);
                setRechnungAngefordert(false);
                setShowRechnungAnfordern(false);
            },
            error => {
                onError("Fehler: " + error.message);
                setRechnungAngefordert(false);
                setShowRechnungAnfordern(false);
            }
        );
    }

    return <>
        <DHButtonDefault label="Rechnung anfordern" disabled={disabled || rechnungAngefordert} onClick={() => setShowRechnungAnfordern(true)}/>
        {showRechnungAnfordern && <ConfirmWithQuestionDialog header="Rechnung anfordern"
                                                             textOben="Bitte fordere die Rechnung nur an, sofern du wirklich einen Pro-Account von darthelfer erwerben möchtest. Du verpflichtest dich damit die Rechnung zu bezahlen und erhälst dafür einen Pro-Account für ein Jahr."
                                                             textUnten="Möchtest du wirklich eine Rechnung anfordern?"
                                                             visible={true}
                                                             callBackOnNein={() => setShowRechnungAnfordern(false)}
                                                             callBackOnJa={() => rechnungAnfordern()}/>
        }
        {rechnungAngefordert && <div style={{fontSize:14, marginTop:20}}>
            Die Rechnung wurde erfolgreich angefordert.<br/>
            Du kannst die Rechnung auf diesem Dialog anschauen bzw. herunterladen.<br/>
            Wir haben dir den Pro-Account direkt gespeichert. Sofern die Zahlung nicht innerhalb von 7 Tagen bei uns eingeht, werden wir den Pro-Account automatisch wieder stornieren.<br/>
            Bitte überweise umgehend, so dass wir den Zahlungseingang rechtzeitig verbuchen können und dir damit deinen Pro-Account speichern können.<br/>
        </div>}
    </>

}
